export enum EFooterGroup {
  HELP_AND_CONTACT = `helpAndContact`,
  LEGAL = `legal`,
  OPENING_HOURS = `openingHours`,
  PAYMENT_TYPES = `paymentTypes`,
  ABOUT_US = `aboutUs`,
}

export enum EPaymentTypes {
  APPLEPAY = `applepay`,
  EPS = `eps`,
  MASTERCARD = `mastercard`,
  PAYPAL = `paypal`,
  SOFORTUEBERWEISUNG = `sofortueberweisung`,
  VISA = `visa`,
}
